module.exports = __webpack_public_path__ + "media/images/category_icons/cars-e671055e28ae7e83323053d7503d10c5.svg";